<template lang="pug">
BriqDialog(v-if="showDeleteProductDialog" @close="$emit('close')")
  h2.mb-S Delete Product
  div(v-if="canProductBeDeleted")
    p.mb-S Are you sure that you want to delete this product?
    .actions
      BriqButton(variant="text" @click="$emit('close')") Cancel
      BriqSubmitButton(@click="$emit('delete')" :disabled="deletingProduct" :pending="deletingProduct"  variant="delete" data-test-id="delete-product-button") Delete
  div(v-else)
    p.mb-S The product cannot be deleted because it is part of the following deals:
    .pl-M
      ul(v-for="linkedDealName in firstFiveLinkedDealNames")
        li {{ linkedDealName }}
    span(v-if="moreThanFiveLinkedDeals > 0") ...and {{ moreThanFiveLinkedDeals }} more
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { prop, isEmpty, pipe, propEq, any, reduce, append } from 'ramda'

export default {
  name: 'DeleteProductDialog',
  props: {
    showDeleteProductDialog: Boolean,
    deletingProduct: Boolean,
    productToBeDeleted: Object,
  },
  computed: {
    ...mapState('inventory', ['deals']),
    linkedDealNames() {
      const hasDeletion = pipe(
        prop('Products'),
        any(propEq('ProductKey', this.productToBeDeleted?.Key)),
      )
      return !this.productToBeDeleted
        ? []
        : reduce((a, n) => (hasDeletion(n) ? append(n.InternalName, a) : a), [])(this.deals)
    },
    firstFiveLinkedDealNames() {
      return this.linkedDealNames.slice(0, 5)
    },
    moreThanFiveLinkedDeals() {
      return this.linkedDealNames.length - this.firstFiveLinkedDealNames.length
    },
    canProductBeDeleted() {
      return isEmpty(this.linkedDealNames)
    },
  },
  methods: {
    ...mapActions('inventory', ['maybeFetchDeals']),
    checkIfProductCanBeDeleted() {},
  },
  mounted() {
    this.maybeFetchDeals()
  },
}
</script>

<style scoped lang="stylus">
.actions
  display flex
  justify-content center
</style>
